import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevrons-up-right', 'IconChevronsUpRight', [["path",{"d":"M9 7h8v8","key":"svg-0"}],["path",{"d":"M5 11h8v8","key":"svg-1"}]]);